import { styled } from "@mui/material";

export const OneRepMaxChartContentRoot = styled("div")({
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  "&[data-source='manual']": {
    overflowY: "auto",
    overscrollBehavior: "contain",
  },
});

export const OneRepMaxChartContainer = styled("div")(({ theme }) => ({
  flex: 1,
  position: "relative",
  marginRight: theme.spacing(3),
  marginBottom: theme.spacing(3),
  // Capped at a share of the panel so the entries table, when shown, always peeks in below it on large screens.
  "[data-source='manual'] > &:not(:last-child)": {
    flex: "0 0 auto",
    height: "max(275px, 70%)",
    marginBottom: 0,
  },
}));
